import { Metadata } from '../../hickory-api';
import { IDENTITY_PROVIDERS_AUTHZ_DOMAIN, AuthZAccessControl } from '../../shared/authentication/access-control';
import { AuthService } from '../../shared/authentication/auth.service';
import { IdpModelAdminFilter, IdpModelWithSummary } from "./IdpModelWithSummary";


export class SelectedIdentityProviderContext {

  public readonly availableActions?: string[];
  public readonly isReadonly?: boolean;
  public readonly canEdit?: boolean;
  public readonly authzDomain = IDENTITY_PROVIDERS_AUTHZ_DOMAIN;
  public readonly isPlaceholder?: boolean;
  public readonly adminFilter?: IdpModelAdminFilter;

  constructor(
    authService: AuthService,
    public readonly tenantId?: number,
    public readonly provider?: IdpModelWithSummary
  ) {
    this.tenantId = tenantId;
    this.provider = provider;
    this.isPlaceholder = provider?.isPlaceholderProvider;
    this.adminFilter = provider?.adminFilter;
    this.availableActions = AuthZAccessControl.getActionsFromEntity(authService, this.authzDomain, provider);
    this.isReadonly = AuthZAccessControl.isReadonlyOrEmpty(this.availableActions);
    this.canEdit = this.availableActions.includes('update');
  }

  updateMetadata(metadata: Metadata): this {
    this.provider.metadata = {
      ...this.provider.metadata,
      ...metadata
    };
    return this;
  }

  validForUpdate(): boolean {
    return !!this.provider?.id && !!this.tenantId && !this.isReadonly && this.canEdit;
  }
}
